import React from "react";
import { Tooltip } from "antd";
import { TooltipProps } from "antd/lib/tooltip";

const Display = (props: TooltipProps) => {
	return <Tooltip {...props}>{props.children}</Tooltip>;
};

export default Display;
